<template>
  <div class="wrapper">
    <div class="is-relative arrows-to-liffery">
      <img src="@/assets/landing-pages/forPeople/2023/arrow-to-liffery.png" alt="Liffery Logo" class="logo-img"/>
    </div>

    <div class="howPeopleUseContainer is-flex is-flex-direction-column is-align-items-center">
      <div class="mb-6">
        <img src="@/assets/landing-pages/new/logo.svg" alt="Liffery Logo" class="logo-img"/>
        <h1 class="logo-title is-inline-block ml-2">
          Liffery
        </h1>
      </div>
      <p class="mb-6 has-text-centered description">
        There are many online paths we take... now they have a home!
<!--        {{ $tc('page.whatIsLiffery.new2023.OHowPeopleUseLifferyArrowsToLiffery.text') }}-->
      </p>
    </div>

    <div class="mb-6 is-flex is-justify-content-center">

      <router-link
          v-if="getIsAuthenticated"
          :to="{name: routeNames.ROUTE_DASHBOARD}"
      >
        <b-button
            type="is-primary"
            class="login-button jumbo2"
        >
          {{ $t('page.whatIsLiffery.new2023.exploreYourJourneys') }}
        </b-button>
      </router-link>

      <b-button
          v-else
          type="is-primary"
          class="login-button jumbo2"
          @click="loginPrompt"
      >
        {{ $tc('page.whatIsLiffery.new2023.exploreYourJourneys') }}
      </b-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.wrapper {
  margin-top: 8rem;
  margin-bottom: 8rem;

  .description {
    width: 465px;
    max-width: 85%;
    margin: auto;
  }
}

.arrows-to-liffery {
  img {
    position: absolute;
    left: calc(50% - 332px);
    top: -250px;
  }
}

@media screen and (max-width: $tablet) {
  .arrows-to-liffery {
    display: none;
  }
}

</style>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { AuthenticationStore } from '@/store';
import { RouteNames } from '@/router/RouteNames';
import { EnumRegisteredFromAction } from '@/store/modules/interfaces/AuthenticationModule';

@Component
export default class OHowPeopleUseLifferySoloWoman extends Vue {
  routeNames = RouteNames;

  get getIsAuthenticated () {
    return AuthenticationStore.getAuthenticated;
  }

  loginPrompt () {
    AuthenticationStore.TOGGLE_PROMPT_SIGNUP({
      state: true,
      metaData: {
        registeredFromAction: EnumRegisteredFromAction.ctaReminder
      }
    });
  }
}
</script>
